var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGains(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.75 10.0446V18.4016C32.75 18.6786 32.6399 18.9444 32.444 19.1403C32.2481 19.3362 31.9824 19.4462 31.7054 19.4462C31.4283 19.4462 31.1626 19.3362 30.9667 19.1403C30.7708 18.9444 30.6608 18.6786 30.6608 18.4016V12.5661L19.909 23.3192C19.812 23.4163 19.6968 23.4933 19.5699 23.5459C19.4431 23.5985 19.3072 23.6255 19.1699 23.6255C19.0326 23.6255 18.8967 23.5985 18.7699 23.5459C18.6431 23.4933 18.5279 23.4163 18.4308 23.3192L13.9468 18.8338L5.28427 27.4976C5.08826 27.6937 4.82241 27.8038 4.5452 27.8038C4.268 27.8038 4.00215 27.6937 3.80613 27.4976C3.61012 27.3016 3.5 27.0358 3.5 26.7586C3.5 26.4814 3.61012 26.2155 3.80613 26.0195L13.2077 16.6179C13.3047 16.5208 13.42 16.4437 13.5468 16.3912C13.6736 16.3386 13.8095 16.3115 13.9468 16.3115C14.0841 16.3115 14.22 16.3386 14.3468 16.3912C14.4736 16.4437 14.5889 16.5208 14.6859 16.6179L19.1699 21.1033L29.1839 11.0892H23.3484C23.0714 11.0892 22.8056 10.9792 22.6097 10.7833C22.4138 10.5874 22.3038 10.3217 22.3038 10.0446C22.3038 9.76757 22.4138 9.50187 22.6097 9.30596C22.8056 9.11006 23.0714 9 23.3484 9H31.7054C31.9824 9 32.2481 9.11006 32.444 9.30596C32.6399 9.50187 32.75 9.76757 32.75 10.0446Z",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGains);
export default __webpack_public_path__ + "static/media/gains.d11051bebb7e3b64e9946c5e709dc60a.svg";
export { ForwardRef as ReactComponent };